import { color, IColors } from './color';

export type { IColors };
export default color;
